import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PortalSidebarMenuItemModel } from '../sidebar-list/portal-sidebar-menu.model';

@Component({
  selector: 'app-portal-sidebar-drawer',
  templateUrl: './portal-sidebar-drawer.component.html',
  styleUrls: ['./portal-sidebar-drawer.component.scss'],
  standalone: false
})
export class PortalSidebarDrawerComponent {
  @Input() navList: PortalSidebarMenuItemModel[] = [];
  @Input() title: string;
  @Output() linkClick = new EventEmitter<void>();
  expanded = true;

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
